import { tr } from "date-fns/locale";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { FaCircle } from "react-icons/fa";
import "../../../styles/app.scss";
import ImageLoading from "../../../components/ImageLoading";
import NoDataFound from "../../../components/NoDataFound";
function MarketInvokeTable({
  setInvokeCount,
  invocationState,
  setTotalPages,
  setTotalRows,
  pageNo,
  rowsPerPage,
  searchValue,
  setEndIndex,
  setSelectArray,
  reRender,
}) {
  const lender_id = Number(localStorage.getItem("lender_id"));
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [list, setList] = useState([]);
  const [imageLoading, setImageLoading] = useState(true);

  const handleSelectAll = () => {
    setSelectAll((prevSelectAll) => {
      const newValue = !prevSelectAll;

      if (newValue) {
        const updatedValues = list
          .filter(
            (item) => item.risk_level === "High" && item.loan_type !== "OD"
          )
          .map((item) => item.order_uuid);

        setSelectedItems(updatedValues);
      } else {
        setSelectedItems([]);
      }

      return newValue;
    });
  };

  const fetchDpd = async (controller) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    console.log(token, "token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/invoke/collateral_margin_call?page=${pageNo}&per_page=${rowsPerPage}&filter_name=${searchValue}`,
        options
      );
      if (res.data) {
        setList(res?.data?.collateral_margin_call);
        setTotalPages(
          res?.data?.total_page_count < 1 ? 1 : res?.data?.total_page_count
        );
        setTotalRows(res?.data?.total_records);
      } else {
        setList([]);
      }

      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };
  const formatInvokeDate = (date) => {
    return ` ${5 - date} days ago`;
  };

  const fetchDpdInitiated = async (controller) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/invoke/collateral_margin_call?page=${pageNo}&per_page=${rowsPerPage}&filter_name=${searchValue}&initiate_invoked=true`,
        options
      );
      if (res.data) {
        setList(res?.data?.collateral_margin_call);
        setTotalPages(
          res?.data?.total_page_count < 1 ? 1 : res?.data?.total_page_count
        );
        setTotalRows(res?.data?.total_records);
      } else {
        setList([]);
      }

      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };

  const handleSelectItem = (index) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedItems = [...prevSelectedItems];
      const itemIndex = updatedItems.indexOf(index);
      if (itemIndex !== -1) {
        updatedItems.splice(itemIndex, 1);
      } else {
        updatedItems.push(index);
      }
      console.log(
        list.filter(
          (item) => item.risk_level === "High" && item.loan_type !== "OD"
        ).length,
        "filteredItems",
        updatedItems.length
      );
      setSelectAll(
        updatedItems.length ===
          list.filter(
            (item) => item.risk_level === "High" && item.loan_type !== "OD"
          ).length
      );
      return updatedItems;
    });
  };
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "---";
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }

  function truncateText(text, maxLength) {
    if (text === null) return "---";
    if (text.length > maxLength) {
      return text.slice(0, maxLength - 3) + "...";
    }
    return text;
  }
  useEffect(() => {
    setSelectArray(selectedItems);
    setInvokeCount(selectedItems.length);
  }, [selectedItems]);
  useEffect(() => {
    const controller = new AbortController();
    setSelectedItems([]);
    setSelectAll(false);
    if (invocationState === "initiatedInvocation") {
      fetchDpdInitiated(controller);
    } else {
      fetchDpd(controller);
    }

    return () => {
      controller.abort();
    };
  }, [pageNo, rowsPerPage, searchValue, invocationState, reRender]);
  useEffect(() => {
    setEndIndex(Number(rowsPerPage));
  }, [rowsPerPage]);

  return (
    <div className=" pt-3  w-full bg-white">
      {imageLoading && (
        <div className="w-full h-[calc(100vh-248px)] flex items-center justify-center">
          <ImageLoading />
        </div>
      )}
      {list.length < 1 && !imageLoading ? (
        <div className="w-full h-[calc(100vh-248px)] flex items-center justify-center">
          <NoDataFound />
        </div>
      ) : (
        <>
          {!imageLoading && (
            <div className=" overflow-auto">
              <table className="w-full box-border h-full flex flex-col min-w-[1240px] ">
                <thead className="text-sm font-semibold h-full">
                  <tr className="w-full flex items-center">
                    {lender_id !== 6 && (
                      <th className="text-center pl-3 pr-4 pt-3 pb-2 w-[3%]">
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={(e) => handleSelectAll(e)}
                          className="border-2 border-[#00394d] focus:border-[#00394d]"
                        />
                      </th>
                    )}

                    <th
                      className={`text-left ${
                        lender_id === 6 && "pl-3  pt-3 pb-2"
                      } ${
                        invocationState === "initiatedInvocation"
                          ? "w-[10%]"
                          : "w-[11%]"
                      }`}
                    >
                      Name
                    </th>
                    <th
                      className={`text-left pl-4 ${
                        invocationState === "initiatedInvocation"
                          ? "w-[13%]"
                          : "w-[14%]"
                      }`}
                    >
                      Loan Number
                    </th>
                    <th
                      className={`  text-left ${
                        invocationState === "initiatedInvocation"
                          ? "w-[10%]"
                          : "w-[8%]"
                      }`}
                    >
                      Loan Type
                    </th>
                    <th
                      className={`text-right ${
                        invocationState === "initiatedInvocation"
                          ? "w-[12%]"
                          : "w-[10%]"
                      }`}
                    >
                      Collateral value
                    </th>
                    <th className="text-right  w-[17%]">
                      Outstanding Loan Value
                    </th>
                    <th
                      className={`text-right ${
                        invocationState === "initiatedInvocation"
                          ? "w-[10%]"
                          : "w-[10%]"
                      }`}
                    >
                      Current LTV
                    </th>
                    <th
                      className={`text-right ${
                        invocationState === "initiatedInvocation"
                          ? "w-[14%]"
                          : "w-[12%]"
                      }`}
                    >
                      Collateral Margin
                    </th>
                    <th
                      className={`text-right ${
                        invocationState === "initiatedInvocation"
                          ? "w-[11%]"
                          : "w-[10%]"
                      }`}
                    >
                      Difference
                    </th>

                    {invocationState === "initiatedInvocation" && (
                      <th className=" text-center w-[16%] pl-4 ">
                        Execution Date
                      </th>
                    )}
                    <th
                      className={`text-left ${
                        invocationState === "initiatedInvocation"
                          ? "w-[12%]"
                          : "w-[15%] pl-12"
                      }`}
                    >
                      Risk level
                    </th>
                  </tr>
                </thead>

                <tbody className="  overflow-auto  max-h-[calc(100vh-285px)]">
                  {list.map((data, index) => (
                    <tr
                      key={index}
                      className={`${
                        index % 2 === 0 ? "bg-[#f8f8f8]" : ""
                      } text-xs font-medium w-full flex items-center ${
                        selectedItems.includes(data.order_uuid) &&
                        "!bg-[#b0c2c8]"
                      }`}
                    >
                      {lender_id !== 6 && (
                        <td className="text-center pl-3 pr-4 pt-3 pb-2 w-[3%]">
                          <input
                            title={
                              data?.risk_level !== "High" ||
                              data.loan_type === "OD"
                                ? "Cannot select items with risk level lower than 'High' or overdraft loans"
                                : ""
                            }
                            disabled={
                              data?.risk_level !== "High" ||
                              data.loan_type === "OD"
                            }
                            type="checkbox"
                            checked={selectedItems.includes(data.order_uuid)}
                            onChange={() => handleSelectItem(data.order_uuid)}
                          />
                        </td>
                      )}

                      <td
                        title={data?.name?.length > 19 ? data.name : ""}
                        className={`text-left ${
                          lender_id === 6 && "pl-3  pt-3 pb-2"
                        } ${
                          invocationState === "initiatedInvocation"
                            ? "w-[10%]"
                            : "w-[11%]"
                        }`}
                      >
                        {truncateText(data?.name, 19) || "---"}
                      </td>
                      <td
                        className={`text-left pl-4 text-[#004682] ${
                          invocationState === "initiatedInvocation"
                            ? "w-[13%]"
                            : "w-[14%]"
                        }`}
                      >
                        <Link
                          to={`../individuals/${data.user_uuid}?name=${data.name}`}
                        >
                          {data?.account_no || "---"}{" "}
                        </Link>
                      </td>
                      <td
                        className={` text-left ${
                          invocationState === "initiatedInvocation"
                            ? "w-[10%]"
                            : "w-[8%]"
                        }`}
                      >
                        {data?.loan_type || "---"}
                      </td>
                      <td
                        className={`text-right pl-4 ${
                          invocationState === "initiatedInvocation"
                            ? "w-[12%]"
                            : "w-[10%]"
                        }`}
                      >
                        {formatToIndianRupees(data?.collateral_value) || "---"}{" "}
                      </td>
                      <td className="text-right  w-[17%]">
                        {formatToIndianRupees(data.outstanding_loan_value) ||
                          "---"}
                      </td>
                      <td
                        className={`text-right ${
                          invocationState === "initiatedInvocation"
                            ? "w-[10%]"
                            : "w-[10%]"
                        }`}
                      >
                        {data?.current_ltv ? data?.current_ltv + "%" : "---"}
                      </td>
                      <td
                        className={`text-right ${
                          invocationState === "initiatedInvocation"
                            ? "w-[14%]"
                            : "w-[12%]"
                        }`}
                      >
                        {data?.collateral_margin
                          ? data.collateral_margin + "%"
                          : "---"}
                      </td>
                      <td
                        className={`text-right ${
                          invocationState === "initiatedInvocation"
                            ? "w-[11%]"
                            : "w-[10%]"
                        }`}
                      >
                        {`${formatToIndianRupees(data?.difference) || "---"} `}
                      </td>

                      {invocationState === "initiatedInvocation" && (
                        <td className="text-center w-[16%] pl-4 text-[10px]">
                          <span className=" text-[#262626] mr-2">--</span>
                          <span className=" py-1 px-2 bg-[#D4ebff] rounded-xl text-[#004682] ">
                            --
                          </span>
                        </td>
                      )}
                      {/* <td
                      className={`text-right pr-3 text-[#0ba300]  ${
                        invocationState === "initiatedInvocation"
                          ? "w-[11%]"
                          : "w-[16%]"
                      } ${data.difference < 0 ? " text-[#e00000]" : ""} `}
                    >
                      {`${formatToIndianRupees(data.difference)} (${Math.abs(
                        data.percentage
                      )}%)`}
                    </td> */}
                      <td
                        className={`text-right ${
                          invocationState === "initiatedInvocation"
                            ? "w-[12%]"
                            : "w-[15%] pl-12"
                        } flex justify-start`}
                      >
                        <span
                          className={`border border-solid rounded-full py-1 px-4 flex gap-2 w-fit items-center ${
                            data.risk_level === "Critical"
                              ? "border-[#C82333] text-[#C82333]"
                              : data?.risk_level === "High"
                              ? "border-[#C66A00] text-[#C66A00]"
                              : data?.risk_level === "Moderate"
                              ? "border-[#D39E00] text-[#D39E00]"
                              : "border-[#218838] text-[#218838]"
                          }`}
                        >
                          <FaCircle
                            className={`${
                              data?.risk_level === "Critical"
                                ? "bg-[#C82333] text-[#C82333]"
                                : data?.risk_level === "High"
                                ? "bg-[#C66A00] text-[#C66A00]"
                                : data?.risk_level === "Moderate"
                                ? "bg-[#D39E00] text-[#D39E00]"
                                : "bg-[#218838] text-[#218838]"
                            } rounded-full`}
                          />
                          {data?.risk_level}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default MarketInvokeTable;
